export const importFromCsv = {
  title: 'タンクのCSVインポート',
  importSuccessfully: 'タンクのインポートに成功しました！',
  importFailed: 'タンクのインポートに失敗しました！',
}
